import { oc } from '@orpc/contract';
import { vehicleAttributeOptionsSchema } from '../schemas/vehicles.schemas.js';
/**
 * Declared **before** the `{vehicleId}` sibling, so the static path wins (plan §2.4). The values are the
 * ones already in use in this workspace — suggestions, never a controlled vocabulary.
 */
export const getVehicleAttributeOptionsContract = oc
    .route({
    method: 'GET',
    path: '/vehicles/attribute-options',
    tags: ['Vehicles'],
    summary: 'Distinct identity values already recorded on stock vehicles',
})
    .output(vehicleAttributeOptionsSchema);
//# sourceMappingURL=get-vehicle-attribute-options.contract.js.map